import { render, staticRenderFns } from "./UcValidityPeriod.yaml?vue&type=template&id=44611f9f&component"
import script from "./UcValidityPeriod.yaml?vue&type=script&lang=ts&component"
export * from "./UcValidityPeriod.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports